import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-create-shop',
  templateUrl: './create-shop.component.html',
  styleUrls: ['./create-shop.component.css']
})
export class CreateShopComponent implements OnInit {
  
  pageName = "Create New Store";

  constructor() { }

  ngOnInit() {
  }

  createShop()
  {
  	alert('shop created');
    $('#initialise-page').trigger('click');
  }

}
